const STAGE = {
  development: {
    url: 'https://vinceacademy.ngrok.app',
  },
  homologation: {
    url: 'https://temp.vinceacademy.com.br',
  },
  production: {
    url: 'https://api.vinceacademy.com.br',
  },
};

// REACT_APP_API_STAGE=development npm start  -> aponta para a API local exposta no ngrok
// REACT_APP_API_STAGE=homologation npm run build -> build para temp.admin.vinceacademy.com.br (API de homologação)
const SELECTED_STAGE = STAGE[process.env.REACT_APP_API_STAGE] ? process.env.REACT_APP_API_STAGE : 'production';

export const API_URL = `${STAGE[SELECTED_STAGE].url}/api/v1`;

export const BROWSER_LANGUAGE = window.navigator.language;
